export const SPANISH_STATES: Record<string, string> = {
  INITIALIZED: 'Inicializado',
  ACCEPTED: 'En curso',
  ENDED: 'Finalizado'
}
